import gsap from "gsap";

export const parallax = (e) => {
    gsap.matchMedia().add(
        "(min-width: 900px)", () => {
            const tl = gsap.timeline({
                defaults: {
                    duration: 0.6,
                    delay: 0.2
                }
            });
            switch(e) {
                case 'terms':
                    return tl.from('.post__content', {
                        y: '100rem'
                    });
                case 'product':
                case 'impact':
                    return tl.from('.leadspace-with-text-and-img__img', {
                        y: '100rem'
                    });
                case 'about':
                    return tl.from('.leadspace-with-slider-and-text__swiper', {
                        y: '100rem'
                    });
            }
        }
    )
}